module.exports = __webpack_public_path__ + "media/images/coffeebean-4d13a01890fd17c6c74116e5eef88fb5.png";